// extracted by mini-css-extract-plugin
export default {"content_wrapper":"styles_content_wrapper__jedib","content_background":"styles_content_background__IFMXi"};